/**
 * Section features component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Cards from '../cards/cards';

export default class SectionFeatures extends PureComponent {

	render() {
		
		const { data, items, template } = this.props;
		
		return (
			
			<div className="section text-center">
				<div className="container">

					{ !! data.title && <h2>{data.title}</h2> }
					{ !! data.lead && <p className="lead">{data.lead}</p> }
					{ !! data.title && <hr className="sm" /> }

					<Cards items={items} template={template} />
					
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-features.js